// Function to check if two lists are equal (order-insensitive)
export const areListsEqual = (list1, list2) => {
    if (list1.length === 0 && list2.length === 0) return true; // Explicit check for empty lists
    if (list1.length !== list2.length) return false;

    // Convert both lists to sets for order-insensitive comparison
    const set1 = new Set(list1);
    const set2 = new Set(list2);

    return [...set1].every(item => set2.has(item));
};